/**
 * Injection des headers d'auth API sur fetch (Mini App + signet).
 * Fichier séparé pour éviter les soucis d'export webpack/CRA.
 *
 * Tokens séparés :
 * - activationPwaToken : uniquement mode Access (?mode=access)
 * - pwaToken : boutique / signet
 * → évite qu'un token activation vole l'identité d'un client shop
 */

const DEVICE_ID_STORAGE_KEY = 'telegramShopDeviceId';
const SHOP_PWA_KEY = 'pwaToken';
const ACT_PWA_KEY = 'activationPwaToken';

export function getApiAuthHeaders(extra = {}) {
  const headers = { ...extra };
  let isAccessMode = false;
  try {
    isAccessMode = new URLSearchParams(window.location.search).get('mode') === 'access';
  } catch { /* */ }

  try {
    const initData = window.Telegram?.WebApp?.initData;
    if (initData) headers['x-telegram-init-data'] = initData;
  } catch { /* */ }

  let pwa = '';
  try {
    if (isAccessMode) {
      // Mode Access : ?t= → activationPwaToken uniquement (pas le token boutique)
      try {
        pwa = new URLSearchParams(window.location.search).get('t') || '';
      } catch { /* */ }
      if (!pwa) pwa = window.localStorage?.getItem(ACT_PWA_KEY) || '';
      if (pwa) {
        headers['x-pwa-token'] = pwa;
        try { window.localStorage.setItem(ACT_PWA_KEY, pwa); } catch { /* */ }
      }
    } else {
      // Mode boutique : on envoie le pwaToken shop.
      // IMPORTANT : on ne supprime PLUS le token boutique même s'il correspond au token
      // activation — les clients créés via le bot activation ont UN SEUL token dans la DB.
      // Les clients shop préexistants (antérieurs au bot activation) n'ont souvent AUCUN
      // token dans activationPwaToken, donc la comparaison "pwa === actOnly" ne les touche pas.
      // En revanche supprimer le token boutique cassait leur auth et les renvoyait au modal nom.
      pwa = window.localStorage?.getItem(SHOP_PWA_KEY) || '';
      if (pwa) headers['x-pwa-token'] = pwa;
    }
  } catch { /* */ }

  // Boutique : toujours envoyer deviceId si dispo (même avec pwa shop) pour stabilité signet
  // Access : jamais de deviceId boutique
  if (!isAccessMode) {
    try {
      const deviceId =
        window.localStorage?.getItem(DEVICE_ID_STORAGE_KEY) ||
        window.localStorage?.getItem('deviceId') ||
        '';
      if (deviceId && String(deviceId).length >= 8) {
        headers['x-device-id'] = String(deviceId);
      }
    } catch { /* */ }
  }
  return headers;
}

export function installApiAuthFetch() {
  if (typeof window === 'undefined' || window.__gsAuthFetchInstalled) return;
  const original = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    try {
      const url = typeof input === 'string' ? input : input?.url || '';
      const isApi =
        /\/api\//.test(url) ||
        /\/api$/.test(url) ||
        /activation\//.test(url) ||
        /global-strains\.shop/.test(url) ||
        /\/(send|client\/|status\/|nfc\/)/.test(url);
      if (isApi) {
        const merged = new Headers(
          init.headers || (typeof input !== 'string' ? input?.headers : undefined) || {}
        );
        const auth = getApiAuthHeaders();
        Object.keys(auth).forEach((k) => {
          const v = auth[k];
          if (v != null && !merged.has(k)) merged.set(k, v);
        });
        // Cookies gs_cid / gs_nfc nécessaires pour auth signet + NFC
        const next = { ...init, headers: merged };
        if (next.credentials == null) next.credentials = 'include';
        init = next;
      }
    } catch { /* soft-fail */ }
    return original(input, init);
  };
  window.__gsAuthFetchInstalled = true;
}